import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpenCheck, Users, Eye, Star } from 'lucide-react';
import { useLang } from '../../hooks/useLang';
import StatTile from '../charts/StatTile';
import { formatCompact } from '../charts/chartTheme';

// The four numbers a creator actually wants on arrival. Each tile is a link
// into the matching Analytics tab — the dashboard answers "how am I doing",
// Analytics answers "why".
const ReachRow = ({ reach }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  if (!reach) return null;

  const toAnalytics = (tab) => navigate(urlLanguage(`/analytics?tab=${tab}`));

  const tiles = [
    {
      icon: BookOpenCheck,
      label: 'Readers',
      value: formatCompact(reach.readers?.value || 0),
      change: reach.readers?.change,
      tab: 'audience',
    },
    {
      icon: Users,
      label: 'Followers',
      value: formatCompact(reach.followers?.value || 0),
      change: reach.followers?.change,
      tab: 'audience',
    },
    {
      icon: Eye,
      label: 'Profile views',
      value: formatCompact(reach.profileViews?.value || 0),
      change: reach.profileViews?.change,
      tab: 'audience',
    },
    {
      icon: Star,
      label: 'Avg rating',
      value: reach.rating?.count ? `${reach.rating.value}` : '—',
      // A rating average has no meaningful period-over-period delta at these
      // volumes, so the tile says how many ratings it rests on instead.
      hint: reach.rating?.count
        ? `from ${reach.rating.count} rating${reach.rating.count === 1 ? '' : 's'}`
        : 'no ratings yet',
      tab: 'materials',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
      {tiles.map((tile) => (
        <StatTile
          key={tile.label}
          icon={tile.icon}
          label={tile.label}
          value={tile.value}
          change={tile.change}
          hint={tile.hint}
          onClick={() => toAnalytics(tile.tab)}
        />
      ))}
    </div>
  );
};

export default ReachRow;
